import React from 'react';
import FileTypeGroup from './FileTypeGroup';
import OrgAssetsModal from './OrgAssetsModal';
import FileNav from './FileNav';
import { ButtonGroup, Nav, NavItem, NavLink, Col, Row, TabContent, TabPane } from 'reactstrap';
import { iconForGroup, groupForFile } from '../helpers/FileHelpers';
import { FILE_TYPES, FILE_GROUPS } from '../constants/Fixtures';

export default class FileList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      target: this.props.target,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.target !== prevProps.target) {
      this.setState({target: this.props.target});
    }
  }

  getFiles() {
    return this.props.files || [];
  }

  getFilesByType = () => {
    const grouped = {};
    this.getFiles().map((file) => {
      const group = groupForFile(file);
      if (grouped[group] != undefined) {
        grouped[group].push(file);
      } else {
        grouped[group] = [file];
      }
    });
    return grouped;
  }

  isCondensedGroup(type) {
    return this.props.target ? type !== this.props.target : false;
  }

  categoryName = key => key === 'undefined' ? 'uncategorized' : this.getFileTypeName(key)

  getFileTypeName(slug) {
    return FILE_TYPES[slug] || slug;
  }

  getFileGroupName(slug) {
    return FILE_GROUPS[slug] || slug;
  }

  selectGroup = (newGroup) =>{
    this.setState({target: newGroup});
  }

  groupedFiles = () => {
    const grouped = this.getFilesByType();
    const keys = Object.keys(grouped).sort((a, b) => this.categoryName(a).toLowerCase() > this.categoryName(b).toLowerCase());
    const typeIndex = keys.indexOf(this.getFileGroupName(this.props.target));
    var activeIndex = keys.indexOf(this.getFileGroupName(this.state.target));

    if (keys.length === 0) {
      return (
        <p style={{textAlign: 'center'}} className="h2 text-muted mt-3">
          Click "Upload" to add files.
        </p>);
    } else {
      return (
        <Row>
          <Col sm={2}>
            <Nav vertical pills>
              {keys.map((key, index) =>
                this.fileGroupTab(key, grouped[key], index, activeIndex),
              )}
            </Nav>
          </Col>
          <Col sm={10}>
            <TabContent activeTab={activeIndex}>
              {keys.map((key, index) =>
                this.fileListTab(key, grouped[key], index, activeIndex),
              )}
            </TabContent>
          </Col>
        </Row>
      );

    }
  }

  fileGroupTab = (type, group, index, typeIndex) => {
    const category = this.categoryName(type);
    return (<NavItem key={type} className={typeIndex == index ? 'active' : ''}>
      <NavLink
      onClick={() => this.selectGroup(type)}
      role="tab"
    >
      <FileNav
        icon={type}
        category={category}
        size={group.length}
      />
    </NavLink>
    </NavItem>);
  }

  fileListTab = (type, group, index, typeIndex) => {
    const category = this.categoryName(type);
    return (
        <TabPane tabId={index} key={`${type}-files`}>
          <FileTypeGroup
            category={category}
            condensed={this.isCondensedGroup(type)}
            type={type}
            fileGroup={group}
            projectId={this.props.projectId}
            destroy={this.props.destroy}
            destroyGroup={this.props.destroyGroup}
            updateGroup={this.props.updateGroup}
            update={this.props.update}
            getStatistics={this.props.getStatistics}
            getGroupStatistics={this.props.getGroupStatistics}
            getChecks={this.props.getChecks}
            cover={this.props.cover}
            projectUpdate={this.props.projectUpdate}
          />
        </TabPane>
    );
  }

  getOrgAssets = () => {
    const orgAssets = this.props.org_assets || [];
    return orgAssets.map((asset) => {
      const match = this.getFiles().find(file => file.name === asset.name);
      asset.disabled = !!match;
      return asset;
    });
  }

  canMakeSample = () => {
    let hasSam = false;
    let viableSam = true;
    this.getFiles().map(file => {
      if (file.type === 'sam') {
        hasSam = true;
        if (file.traits && !file.traits.sample_viable || !file.traits) {
          viableSam = false
        }
      }
    });
    return hasSam && viableSam;
  }

  render() {
    const orgAssets = this.getOrgAssets();
    return (<div className="project-files">
      <div className="project-files-header">
        <h2>Files</h2>
        <ButtonGroup className="project-files-actions">
          {orgAssets.length > 0 ?
            <OrgAssetsModal
              modalOpen
              closeModal={() => {}}
              orgAssets={orgAssets}
              addOrgAssets={this.props.addOrgAssets}
            /> : null}
          {this.canMakeSample() ? <a
            className="btn btn-success"
            title="Make a sample"
            href={`/wfdw/projects/${this.props.projectId}/sample`}
          >
            Sample Generator
          </a> : null}
        </ButtonGroup>
      </div>
      {this.groupedFiles()}
    </div>);
  }
}
